import { validateOnCompletedAndOnErrorOptions } from '@netfront/common-library';
import { useLoggedGeladaMutation } from '@netfront/gelada-identity-library';

import { RESEND_ACTIVATION_EMAIL_MUTATION } from './useResendActivationEmail.graphql';
import type {
  IHandleResendActivationEmailParams,
  IResendActivationEmailMutationGraphQLResponse,
  IResendActivationEmailMutationVariables,
  IUseResendActivationEmail,
  IUseResendActivationEmailOptions,
} from './useResendActivationEmail.interfaces';

const useResendActivationEmail = (options?: IUseResendActivationEmailOptions): IUseResendActivationEmail => {
  const { mutation, onCompleted, onCompletedAsync, onError, onErrorAsync, product, projectId: optionProjectId } = options ?? {};

  validateOnCompletedAndOnErrorOptions({
    onCompleted,
    onCompletedAsync,
    onError,
    onErrorAsync,
  });

  const [executeResendActivationEmail, { loading: isLoading }] = useLoggedGeladaMutation<
    IResendActivationEmailMutationGraphQLResponse,
    IResendActivationEmailMutationVariables
  >({
    mutation: mutation ?? RESEND_ACTIVATION_EMAIL_MUTATION,
    options: {
      onCompleted: (data) => {
        const { 
          user: {
            resendActivationEmail: isCompleted 
          }
        } = data;

        if (onCompleted) {
          onCompleted({
            isCompleted,
          });
        }

        if (onCompletedAsync) {
          void onCompletedAsync({
            isCompleted,
          });
        }
      },
      onError: (error) => {
        if (onError) {
          onError(error);
        }

        if (onErrorAsync) {
          void onErrorAsync(error);
        }
      },
    },
    product,
    projectId: optionProjectId,
  });

  const handleResendActivationEmail = async ({ userId, projectId }: IHandleResendActivationEmailParams) => {
    await executeResendActivationEmail({
      variables: {
        projectId,
        userId,
      },
    });
  };

  return {
    handleResendActivationEmail,
    isLoading,
  };
};

export { useResendActivationEmail };
